"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { getValueSpecFromSchema, doesSchemaMatchValueType } from '../ComboBox/value-spec.mjs';
import useDataBuilder from './use-data-builder.mjs';
import useDataBuilderField from './use-data-builder-field.mjs';

function useDataBuilderFieldCanUseVarFromVariables() {
  const { field, localSchema } = useDataBuilderField();
  const localSchemaIsArrayOrObject = ["array", "object"].includes(localSchema?.type || "");
  if (!localSchemaIsArrayOrObject) {
    return false;
  }
  const valueSpec = getValueSpecFromSchema(localSchema);
  const hasMatchedVariables = Object.values(field?.variablesSchema?.properties ?? {}).some(
    (schema) => doesSchemaMatchValueType(schema, valueSpec, true)
  );
  const hasOptionFactories = (field?.optionFactories ?? []).length > 0;
  return hasMatchedVariables || hasOptionFactories;
}
function useIsFieldFrozen() {
  const { frozenFieldsLocators = [] } = useDataBuilder();
  const { field } = useDataBuilderField();
  return frozenFieldsLocators.some(
    (frozenFieldLocator) => frozenFieldLocator && field?.valueLocator === frozenFieldLocator
  );
}

export { useDataBuilderFieldCanUseVarFromVariables, useIsFieldFrozen };
